var chunkMapping = {
	"100": [
		1100
	],
	"252": [
		1252
	],
	"276": [
		3276
	],
	"284": [
		5284
	],
	"292": [
		6911
	],
	"330": [
		4330
	],
	"356": [
		1356
	],
	"412": [
		6412
	],
	"548": [
		9548
	],
	"550": [
		3550
	],
	"562": [
		2562
	],
	"614": [
		1614
	],
	"740": [
		740
	],
	"762": [
		6762
	],
	"815": [
		6815
	],
	"818": [
		8818
	],
	"880": [
		9880
	]
};
var idToExternalAndNameMapping = {
	"740": [
		"default",
		"./FixitTool",
		5370
	],
	"1100": [
		"default",
		"./InSeasonWeb",
		8686
	],
	"1252": [
		"default",
		"./Settings",
		1027
	],
	"1356": [
		"default",
		"./ModuleFederationExample",
		1127
	],
	"1614": [
		"default",
		"./TccReportsPlugin",
		9856
	],
	"2562": [
		"default",
		"./VariableRate",
		4356
	],
	"3276": [
		"default",
		"./DmbWeb",
		7545
	],
	"3550": [
		"default",
		"./DataInboxWeb",
		1024
	],
	"4330": [
		"default",
		"./ProgramsPlugin",
		372
	],
	"5284": [
		"default",
		"./AppsMarketplacePlugin",
		6746
	],
	"6412": [
		"default",
		"./DataHub",
		701
	],
	"6762": [
		"default",
		"./TccScriptCreatorPlugin",
		1490
	],
	"6815": [
		"default",
		"./FieldSelectionPlugin",
		9222
	],
	"6911": [
		"default",
		"./CropPlanning",
		261
	],
	"8818": [
		"default",
		"./OperationHub",
		7810
	],
	"9548": [
		"default",
		"./InformationArchitecture",
		1391
	],
	"9880": [
		"default",
		"./Dashboard",
		2814
	]
};
var idToRemoteMap = {
	"740": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"1100": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"1252": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"1356": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"1614": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"2562": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"3276": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"3550": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"4330": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"5284": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"6412": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"6762": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"6815": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"6911": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"8818": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"9548": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"9880": [
		{
			"externalType": "promise",
			"name": ""
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"740": {
		"shareScope": "default",
		"name": "./FixitTool",
		"externalModuleId": 5370,
		"remoteName": ""
	},
	"1100": {
		"shareScope": "default",
		"name": "./InSeasonWeb",
		"externalModuleId": 8686,
		"remoteName": ""
	},
	"1252": {
		"shareScope": "default",
		"name": "./Settings",
		"externalModuleId": 1027,
		"remoteName": ""
	},
	"1356": {
		"shareScope": "default",
		"name": "./ModuleFederationExample",
		"externalModuleId": 1127,
		"remoteName": ""
	},
	"1614": {
		"shareScope": "default",
		"name": "./TccReportsPlugin",
		"externalModuleId": 9856,
		"remoteName": ""
	},
	"2562": {
		"shareScope": "default",
		"name": "./VariableRate",
		"externalModuleId": 4356,
		"remoteName": ""
	},
	"3276": {
		"shareScope": "default",
		"name": "./DmbWeb",
		"externalModuleId": 7545,
		"remoteName": ""
	},
	"3550": {
		"shareScope": "default",
		"name": "./DataInboxWeb",
		"externalModuleId": 1024,
		"remoteName": ""
	},
	"4330": {
		"shareScope": "default",
		"name": "./ProgramsPlugin",
		"externalModuleId": 372,
		"remoteName": ""
	},
	"5284": {
		"shareScope": "default",
		"name": "./AppsMarketplacePlugin",
		"externalModuleId": 6746,
		"remoteName": ""
	},
	"6412": {
		"shareScope": "default",
		"name": "./DataHub",
		"externalModuleId": 701,
		"remoteName": ""
	},
	"6762": {
		"shareScope": "default",
		"name": "./TccScriptCreatorPlugin",
		"externalModuleId": 1490,
		"remoteName": ""
	},
	"6815": {
		"shareScope": "default",
		"name": "./FieldSelectionPlugin",
		"externalModuleId": 9222,
		"remoteName": ""
	},
	"6911": {
		"shareScope": "default",
		"name": "./CropPlanning",
		"externalModuleId": 261,
		"remoteName": ""
	},
	"8818": {
		"shareScope": "default",
		"name": "./OperationHub",
		"externalModuleId": 7810,
		"remoteName": ""
	},
	"9548": {
		"shareScope": "default",
		"name": "./InformationArchitecture",
		"externalModuleId": 1391,
		"remoteName": ""
	},
	"9880": {
		"shareScope": "default",
		"name": "./Dashboard",
		"externalModuleId": 2814,
		"remoteName": ""
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}